export const Data = [
    {
        question: 'Question 1',
        answer: 'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Deleniti, minus!'
    },
    
    {
        question: 'Question 2',
        answer: 'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Deleniti, minus!'
    },
    {
        question: 'Question 3',
        answer: 'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Deleniti, minus!'
    },
    {
        question: 'Question 4',
        answer: 'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Deleniti, minus!'
    },
    {
        question: 'Question 5',
        answer: 'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Deleniti, minus!'
    },

]